const constants = {
  GET_PARTNERS: 'GET_PARTNERS',
  GET_PARTNERS_SUCCESS: 'GET_PARTNERS_SUCCESS',
  GET_PARTNERS_ERROR: 'GET_PARTNERS_ERROR',

  GET_PRODUCTS: 'GET_PRODUCTS',
  GET_PRODUCTS_SUCCESS: 'GET_PRODUCTS_SUCCESS',
  GET_PRODUCTS_ERROR: 'GET_PRODUCTS_ERROR',

  SELECT_PRODUCT: 'SELECT_PRODUCT',
  SELECT_PRODUCT_SUCCESS: 'SELECT_PRODUCT_SUCCESS',
  SELECT_PRODUCT_ERROR: 'SELECT_PRODUCT_ERROR',

  GET_SELECTED_PRODUCTS: 'GET_SELECTED_PRODUCTS',
  GET_SELECTED_PRODUCTS_SUCCESS: 'GET_SELECTED_PRODUCTS_SUCCESS',
  GET_SELECTED_PRODUCTS_ERROR: 'GET_SELECTED_PRODUCTS_ERROR',
  
  GET_TOKENS: 'GET_TOKENS',
  GET_TOKENS_SUCCESS: 'GET_TOKENS_SUCCESS',
  GET_TOKENS_ERROR: 'GET_TOKENS_ERROR',

  GET_SLOTS: 'GET_SLOTS',
  GET_SLOTS_SUCCESS: 'GET_SLOTS_SUCCESS',
  GET_SLOTS_ERROR: 'GET_SLOTS_ERROR',

  GET_ME: 'GET_ME',
  GET_ME_SUCCESS: 'GET_ME_SUCCESS',
  GET_ME_ERROR: 'GET_ME_ERROR'
}

module.exports = constants;